import { service } from '@ember/service';
import { Ability } from 'ember-can';
import isProductDisabled from 'garaje/helpers/product-disabled';
import type AuthzService from 'garaje/services/authz';
import type CurrentAdminService from 'garaje/services/current-admin';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';

export default class ScreenAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare state: StateService;

  get isEnabled(): boolean {
    const featureFlagEnabled = this.featureFlags.isEnabled('screens-v1');
    const hasPlan = !!this.state.features?.hasScreensDevices;
    const hasAccess = featureFlagEnabled || hasPlan;

    return !isProductDisabled('screens') && hasAccess;
  }

  get canVisit(): boolean {
    const canView = this.canViewContent || this.canViewDevices;

    return canView && this.isEnabled;
  }

  get canCreateContent(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.SCREENS_CONTENT_CREATE);
  }

  get canViewContent(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.SCREENS_CONTENT_READ);
  }

  get canEditContent(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.SCREENS_CONTENT_UPDATE);
  }

  get canDeleteContent(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.SCREENS_CONTENT_DELETE);
  }

  get canCreateDevices(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.SCREENS_DEVICE_CREATE);
  }

  get canViewDevices(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.SCREENS_DEVICE_READ);
  }

  get canEditDevices(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.SCREENS_DEVICE_UPDATE);
  }

  get canDeleteDevices(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.SCREENS_DEVICE_DELETE);
  }
}
